import React from "react";
import PropTypes from "prop-types";
import HoverTooltip from "../../../../../../../components/atoms/Tooltip/HoverTooltip";
import { cropNumber } from "../../../../../../../common/helpers/helpers";
import { scoresExplanation } from "../../scoresExplanation";

const scoreTooltip = (transcript, score, color, prediction, index) => {
  return (
    <>
      {transcript && (
        <div className="tw-min-w-64">
          {`Transcript: `}
          <b>{transcript}</b>
        </div>
      )}
      <div className="tw-min-w-64">
        {`Score: `}
        <span
          style={{
            color,
          }}
          data-testid={`tooltip_score_value_${index}`}
        >
          <b>{cropNumber(score)}</b>
        </span>
      </div>
      {prediction && (
        <div className="tw-min-w-64">
          {`Calibrated Prediction: `}
          <span
            style={{
              color,
            }}
          >
            <b>{prediction}</b>
          </span>
        </div>
      )}
    </>
  );
};

const ScoresCell = ({ database, customStyle }) => {
  if (!Object.keys(database || {}).length) return null;
  const scores = database?.scoresArray?.filter((obj) => obj.score !== null);
  if (!scores?.length) return null;
  return (
    <span data-testid="scores_cell_internal">
      <span
        className="varsome-horiz-list-label varsome-dbnsfp-label"
        data-testid="custom_score_label"
        style={customStyle}
      >
        {database?.customKeys?.score}
      </span>
      <span className="varsome-horiz-list-value">
        {scores.length === 1 ? (
          <span
            data-testid="score_value"
            style={{
              color: scores?.[0].color,
            }}
          >
            {cropNumber(scores?.[0].score)}
          </span>
        ) : (
          scores.map((scoreObj, index) => {
            return (
              <HoverTooltip
                key={`${index}-score-tooltip`}
                ContentRenderer={() =>
                  scoreTooltip(
                    scoreObj.transcript,
                    scoreObj.score,
                    scoreObj.color,
                    scoreObj.calibratedPrediction,
                    index
                  )
                }
              >
                <span
                  key={`${index}-score`}
                  data-testid="score_value"
                  style={{
                    color: scoreObj.color,
                  }}
                >
                  {`${cropNumber(scoreObj.score)}${
                    index === scores.length - 1 ? "" : ", "
                  }`}
                </span>
              </HoverTooltip>
            );
          })
        )}
      </span>
      <span>{scoresExplanation(database.name)}</span>
    </span>
  );
};

ScoresCell.propTypes = {
  database: PropTypes.shape({
    scoresArray: PropTypes.arrayOf(PropTypes.shape({})),
    colorPerScore: PropTypes.arrayOf(PropTypes.string),
    scores: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    ),
    name: PropTypes.string,
    customKeys: PropTypes.shape({
      score: PropTypes.string,
      rankscore: PropTypes.string,
    }),
  }),
  customStyle: PropTypes.shape({}),
};

ScoresCell.defaultProps = {
  database: {},
  customStyle: {},
};

export default ScoresCell;
